module.exports = __webpack_public_path__ + "static/media/feature-1-mav.4717d340.png";